/* NeverMove review portal — read-only display of the archived review set.
   Two custom elements: <nm-rating> (buy box) and <nm-reviews> (page section).
   Data is fetched once, lazily, and shared between them. */
(function () {
  'use strict';
  if (window.NeverMoveReviews) return;

  var STAR = '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path fill="currentColor" d="M10 1.6l2.47 5.28 5.53.72-4.07 3.9 1.05 5.62L10 14.4l-4.98 2.72 1.05-5.62L2 7.6l5.53-.72z"/></svg>';
  var FIVE = STAR + STAR + STAR + STAR + STAR;
  var cache = null;

  function load(url) {
    if (!cache) {
      cache = fetch(url, { credentials: 'omit' }).then(function (r) {
        if (!r.ok) throw new Error('Review data unavailable (' + r.status + ')');
        return r.json();
      });
    }
    return cache;
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function stars(v, label) {
    return '<span class="nm-stars" role="img" aria-label="' + esc(label || (v + ' out of 5 stars')) + '">' +
      '<i>' + FIVE + '</i><span class="nm-fill" style="width:' + (v / 5 * 100).toFixed(2) + '%"><i>' + FIVE + '</i></span></span>';
  }

  function num(n) { return Number(n).toLocaleString('en-US'); }

  function monthYear(iso) {
    var d = new Date(iso + 'T12:00:00');
    if (isNaN(d)) return iso;
    return d.toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
  }

  function bars(summary) {
    var out = '<div class="nm-bars">';
    [5, 4, 3, 2, 1].forEach(function (k) {
      var c = summary.distribution[String(k)] || 0;
      var pct = summary.count ? (c / summary.count * 100) : 0;
      out += '<div class="nm-bar"><span>' + k + (k === 1 ? ' star' : ' stars') + '</span>' +
        '<span class="nm-track"><span style="width:' + pct.toFixed(2) + '%"></span></span>' +
        '<span class="nm-n">' + num(c) + '</span></div>';
    });
    return out + '</div>';
  }

  function meter(label, obj) {
    if (!obj || !obj.n) return '';
    var cells = '';
    for (var i = 1; i <= 5; i++) cells += '<i class="' + (i <= Math.round(obj.avg) ? 'nm-on' : '') + '"></i>';
    return '<div><div class="nm-lab">' + esc(label) + '</div><div class="nm-meter">' + cells + '</div>' +
      '<div class="nm-val">' + obj.avg.toFixed(1) + ' <span style="font-weight:400;opacity:.6">· ' + obj.n + ' ratings</span></div></div>';
  }

  /* ---------------- overlay plumbing ---------------- */
  var overlay = null, lastFocus = null;

  function closeOverlay() {
    if (!overlay) return;
    overlay.remove(); overlay = null;
    document.removeEventListener('keydown', onKey);
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function onKey(e) {
    if (e.key === 'Escape') { closeOverlay(); return; }
    if (overlay && overlay.querySelector('.nm-lb')) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); lbGo(-1); return; }
      if (e.key === 'ArrowRight') { e.preventDefault(); lbGo(1); return; }
    }
    if (e.key !== 'Tab' || !overlay) return;
    var f = overlay.querySelectorAll('button, [href], select, [tabindex]:not([tabindex="-1"])');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function openOverlay(html, host) {
    closeOverlay();
    lastFocus = document.activeElement;
    overlay = document.createElement('div');
    overlay.className = 'nm nm-backdrop';
    if (host) overlay.style.setProperty('--nm-sand', getComputedStyle(host).getPropertyValue('--nm-sand') || '#a8896a');
    overlay.innerHTML = html;
    overlay.addEventListener('click', function (e) { if (e.target === overlay) closeOverlay(); });
    document.body.appendChild(overlay);
    document.documentElement.style.overflow = 'hidden';
    document.addEventListener('keydown', onKey);
    var x = overlay.querySelector('.nm-x');
    if (x) { x.addEventListener('click', closeOverlay); x.focus(); }
  }

  function breakdownHTML(data, scopeLabel) {
    var s = data.summary;
    return '<div class="nm-modal" role="dialog" aria-modal="true" aria-label="Rating breakdown">' +
      '<div class="nm-modal-head"><div>' +
      '<div class="nm-eyebrow">Overall rating · ' + esc(scopeLabel) + '</div>' +
      '<div style="display:flex;align-items:center;gap:12px;margin-top:8px">' +
      '<span class="nm-big">' + s.average.toFixed(1) + '</span>' +
      '<span style="font-size:18px">' + stars(s.average) + '</span></div>' +
      '<div class="nm-sub" style="margin-top:6px">' + num(s.count) + ' reviews</div>' +
      '</div><button class="nm-x" type="button" aria-label="Close">&times;</button></div>' +
      bars(s) +
      '<div class="nm-subs">' + meter('Quality', s.subratings.quality) + meter('Value', s.subratings.value) + '</div>' +
      '</div>';
  }

  /* ---------------- lightbox gallery ---------------- */
  var lbList = [], lbIndex = 0;

  function lbHTML() {
    var p = lbList[lbIndex], rev = p.rev, many = lbList.length > 1;
    return '<div class="nm-lb" role="dialog" aria-modal="true" aria-label="Customer photo">' +
      '<div class="nm-img">' +
        '<img src="' + esc(p.src) + '" alt="Customer photo from a ' + rev.r + '-star review">' +
        '<span class="nm-counter">' + (lbIndex + 1) + ' / ' + lbList.length + '</span>' +
        (many ? '<button type="button" class="nm-nav nm-prev" aria-label="Previous photo">‹</button>' +
                '<button type="button" class="nm-nav nm-next" aria-label="Next photo">›</button>' : '') +
      '</div>' +
      '<div class="nm-side">' +
        '<div class="nm-top">' + stars(rev.r) +
          (rev.vp ? '<span class="nm-badge">Verified buyer</span>' : '') +
          (rev.inc ? '<span class="nm-badge nm-inc">Received free product</span>' : '') +
        '</div>' +
        (rev.t ? '<h4 style="margin:0;font-size:1rem;font-weight:600">' + esc(rev.t) + '</h4>' : '') +
        '<p class="nm-body">' + esc(rev.b) + '</p>' +
        '<div class="nm-meta">' +
          rev.uses.map(function (u) { return '<span class="nm-tag">' + esc(u) + '</span>'; }).join('') +
          '<span class="nm-date">' + monthYear(rev.d) + '</span>' +
        '</div>' +
      '</div>' +
      '<button type="button" class="nm-x" aria-label="Close">&times;</button>' +
    '</div>';
  }

  function lbBind() {
    var prev = overlay.querySelector('.nm-prev'), next = overlay.querySelector('.nm-next');
    if (prev) prev.addEventListener('click', function () { lbGo(-1); });
    if (next) next.addEventListener('click', function () { lbGo(1); });
    var x = overlay.querySelector('.nm-x');
    if (x) x.addEventListener('click', closeOverlay);
    /* warm the neighbours so arrowing through feels instant */
    [-1, 1].forEach(function (d) {
      var n = lbList[(lbIndex + d + lbList.length) % lbList.length];
      if (n) { var img = new Image(); img.src = n.src; }
    });
  }

  function lbGo(d) {
    if (!overlay || lbList.length < 2) return;
    lbIndex = (lbIndex + d + lbList.length) % lbList.length;
    overlay.innerHTML = lbHTML();
    lbBind();
    var b = overlay.querySelector(d < 0 ? '.nm-prev' : '.nm-next');
    if (b) b.focus();
  }

  function openLightbox(list, i, host) {
    if (!list || !list.length) return;
    lbList = list;
    lbIndex = i == null ? 0 : i;
    openOverlay(lbHTML(), host);
    lbBind();
  }

  /* ---------------- <nm-rating> ---------------- */
  function NmRating() { return Reflect.construct(HTMLElement, [], NmRating); }
  NmRating.prototype = Object.create(HTMLElement.prototype);
  NmRating.prototype.constructor = NmRating;
  Object.setPrototypeOf(NmRating, HTMLElement);
  NmRating.prototype.connectedCallback = function () {
    var self = this;
    var btn = this.querySelector('.nm-rating');
    if (!btn || btn.dataset.bound) return;
    btn.dataset.bound = '1';
    btn.addEventListener('click', function () {
      btn.dataset.loading = '1';
      load(self.dataset.url).then(function (data) {
        btn.dataset.loading = '';
        openOverlay(breakdownHTML(data, self.dataset.scope || 'NeverMove Rugs'), self);
      }).catch(function () {
        btn.dataset.loading = '';
        var target = document.getElementById(self.dataset.target || 'nevermove-reviews');
        if (target) target.scrollIntoView({ behavior: 'smooth' });
      });
    });
  };

  /* ---------------- <nm-reviews> ---------------- */
  function NmReviews() { return Reflect.construct(HTMLElement, [], NmReviews); }
  NmReviews.prototype = Object.create(HTMLElement.prototype);
  NmReviews.prototype.constructor = NmReviews;
  Object.setPrototypeOf(NmReviews, HTMLElement);

  NmReviews.prototype.connectedCallback = function () {
    var self = this;
    this.page = parseInt(this.dataset.pageSize || '10', 10);
    this.shown = this.page;
    this.filters = { photos: false, ratings: [] };
    this.sort = 'rating';

    var toggle = this.querySelector('.nm-disclose');
    var panel = this.querySelector('.nm-panel');
    if (!toggle || toggle.dataset.bound) return;
    toggle.dataset.bound = '1';

    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
      panel.hidden = open;
      toggle.querySelector('.nm-disclose-label').textContent = open ? self.dataset.labelOpen : self.dataset.labelClose;
      if (!open) self.ensure();
    });

    if (this.dataset.startOpen === 'true') toggle.click();
  };

  NmReviews.prototype.ensure = function () {
    var self = this;
    if (this.data) return;
    var panel = this.querySelector('.nm-panel');
    panel.innerHTML = '<div class="nm-empty">Loading reviews…</div>';
    load(this.dataset.url).then(function (data) {
      self.data = data;
      self.buildPhotos();
      panel.innerHTML =
        '<div class="nm-toolbar">' +
        '<button class="nm-chip" type="button" data-filter="photos" aria-pressed="false">With photos</button>' +
        '<button class="nm-chip" type="button" data-filter="5" aria-pressed="false">5 stars</button>' +
        '<button class="nm-chip" type="button" data-filter="4" aria-pressed="false">4 stars</button>' +
        '<button class="nm-chip" type="button" data-filter="low" aria-pressed="false">3 &amp; below</button>' +
        '<span class="nm-spacer"></span>' +
        '<label for="nm-sort-' + self.dataset.uid + '">Sort</label>' +
        '<select class="nm-select" id="nm-sort-' + self.dataset.uid + '">' +
        '<option value="rating">Highest rated</option><option value="lowest">Lowest rated</option>' +
        '<option value="helpful">Most helpful</option><option value="recent">Most recent</option></select>' +
        '</div>' +
        self.photoStrip() +
        '<div class="nm-list"></div>' +
        '<button class="nm-more" type="button" hidden></button>';
      self.bind();
      self.render();
    }).catch(function (e) {
      panel.innerHTML = '<div class="nm-empty">Reviews couldn’t be loaded right now.</div>';
      if (window.console) console.warn('[NeverMove reviews]', e);
    });
  };

  NmReviews.prototype.buildPhotos = function () {
    var flat = [], map = {};
    this.data.reviews.filter(function (r) { return r.photos.length; })
      .sort(function (a, b) { return b.r - a.r || b.h - a.h; })
      .forEach(function (r) {
        r.photos.forEach(function (p) { map[p] = flat.length; flat.push({ src: p, rev: r }); });
      });
    this.flatPhotos = flat;
    this.photoIndex = map;
  };

  NmReviews.prototype.photoStrip = function () {
    var flat = this.flatPhotos;
    if (!flat.length) return '';
    return '<div class="nm-photos"><span class="nm-eyebrow">Customer photos · ' + flat.length + '</span>' +
      '<div class="nm-pgrid">' + flat.map(function (p, i) {
        return '<button type="button" data-pi="' + i + '" aria-label="Open customer photo">' +
          '<img src="' + esc(p.src) + '" alt="" loading="lazy" width="200" height="200"></button>';
      }).join('') + '</div></div>';
  };

  NmReviews.prototype.bind = function () {
    var self = this;
    this.querySelector('.nm-select').addEventListener('change', function (e) {
      self.sort = e.target.value; self.shown = self.page; self.render();
    });
    Array.prototype.forEach.call(this.querySelectorAll('.nm-chip'), function (c) {
      c.addEventListener('click', function () {
        var f = c.dataset.filter, on = c.getAttribute('aria-pressed') === 'true';
        c.setAttribute('aria-pressed', on ? 'false' : 'true');
        if (f === 'photos') self.filters.photos = !on;
        else self.filters.ratings = on
          ? self.filters.ratings.filter(function (x) { return x !== f; })
          : self.filters.ratings.concat(f);
        self.shown = self.page; self.render();
      });
    });
    Array.prototype.forEach.call(this.querySelectorAll('.nm-pgrid button'), function (b) {
      b.addEventListener('click', function () {
        openLightbox(self.flatPhotos, +b.dataset.pi, self);
      });
    });
    this.querySelector('.nm-more').addEventListener('click', function () {
      self.shown += self.page; self.render();
    });
  };

  NmReviews.prototype.current = function () {
    var f = this.filters;
    var rows = this.data.reviews.filter(function (x) {
      if (f.photos && !x.photos.length) return false;
      if (f.ratings.length) {
        var ok = f.ratings.some(function (k) { return k === 'low' ? x.r <= 3 : x.r === +k; });
        if (!ok) return false;
      }
      return true;
    });
    var s = this.sort;
    return rows.sort(function (a, b) {
      if (s === 'rating') return b.r - a.r || b.h - a.h || (a.d < b.d ? 1 : -1);
      if (s === 'lowest') return a.r - b.r || b.h - a.h;
      if (s === 'helpful') return b.h - a.h || b.r - a.r;
      return a.d < b.d ? 1 : a.d > b.d ? -1 : b.h - a.h;
    });
  };

  NmReviews.prototype.render = function () {
    var self = this;
    var rows = this.current();
    var slice = rows.slice(0, this.shown);
    var list = this.querySelector('.nm-list');

    list.innerHTML = slice.length ? slice.map(function (x) {
      var sub = [];
      if (x.q != null) sub.push('<span>Quality <b>' + x.q + '</b></span>');
      if (x.v != null) sub.push('<span>Value <b>' + x.v + '</b></span>');
      return '<article class="nm-rev">' +
        '<div class="nm-top"><span style="font-size:14px">' + stars(x.r) + '</span>' +
        (x.vp ? '<span class="nm-badge">Verified buyer</span>' : '') +
        (x.inc ? '<span class="nm-badge nm-inc">Received free product</span>' : '') +
        '<span class="nm-date">' + monthYear(x.d) + '</span></div>' +
        (x.t ? '<h4>' + esc(x.t) + '</h4>' : '') +
        '<p class="nm-body">' + esc(x.b) + '</p>' +
        (x.photos.length ? '<div class="nm-thumbs">' + x.photos.map(function (p) {
          return '<button type="button" data-id="' + esc(x.id) + '" data-src="' + esc(p) + '" aria-label="Open customer photo">' +
            '<img src="' + esc(p) + '" alt="" loading="lazy" width="132" height="132"></button>';
        }).join('') + '</div>' : '') +
        (x.rec === true ? '<div class="nm-rec">✓ Recommends this product</div>' : '') +
        '<div class="nm-meta">' + sub.join('') +
        x.uses.map(function (u) { return '<span class="nm-tag">' + esc(u) + '</span>'; }).join('') +
        x.pros.map(function (u) { return '<span class="nm-tag">' + esc(u) + '</span>'; }).join('') +
        (x.h ? '<span style="margin-inline-start:auto">' + x.h + ' found this helpful</span>' : '') +
        '</div>' +
        (x.resp ? '<div class="nm-resp"><span class="nm-eyebrow">Response from NeverMove</span><p>' + esc(x.resp) + '</p></div>' : '') +
        '</article>';
    }).join('') : '<div class="nm-empty">No reviews match those filters.</div>';

    Array.prototype.forEach.call(list.querySelectorAll('.nm-thumbs button'), function (b) {
      b.addEventListener('click', function () {
        openLightbox(self.flatPhotos, self.photoIndex[b.dataset.src], self);
      });
    });

    var more = this.querySelector('.nm-more');
    var left = rows.length - slice.length;
    more.hidden = left <= 0;
    more.textContent = 'Show ' + Math.min(left, this.page) + ' more';
  };

  if (!customElements.get('nm-rating')) customElements.define('nm-rating', NmRating);
  if (!customElements.get('nm-reviews')) customElements.define('nm-reviews', NmReviews);
  window.NeverMoveReviews = { load: load, stars: stars };
})();
